module.exports = __webpack_public_path__ + "TextaNarrow-Bold-webfont.7efacd6764a841a812cb.eot";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Bold-webfont.eot
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Bold-webfont.eot
// module chunks = styles